module.exports = __webpack_public_path__ + "images/pro/icon-pro-downgrade-496df396a9e7dfd386dab498347d24ea.png";